import awaitToJs from 'await-to-js'
import { setAlertBox } from './snackbar'
import Fetch from '@App/helpers/fetch'
import {
  MESSAGE_ERROR,
  RECOVER_PASSWORD_SUCCESS,
  ALERT_COLORS,
  ALERT_DELAY,
  LOGIN_ROUTE,
} from '@App/constantes'
import history from '@App/helpers/history'
import { API_URL } from '@App/configs/rest'

const fetchGetRecoveryPassword = new Fetch()

export const getRecoveryPassword = (email: string) => {
  return async (dispatch: any) => {
    const [err, data] = await awaitToJs(fetchGetRecoveryPassword.post({
      url: `${API_URL}/users/auth/request-reset-password`,
      body: {
        email,
      },
      headers: {
        'content-type': 'application/json',
      },
    }))

    if (!err && data) {
      history.push(LOGIN_ROUTE)

      dispatch(setAlertBox({
        title: data && data.message || RECOVER_PASSWORD_SUCCESS,
        background: ALERT_COLORS.green,
        delay: ALERT_DELAY,
      }))

      return data
    }

    if (err) {
      dispatch(setAlertBox({
        title: err && err.message || MESSAGE_ERROR,
        background: ALERT_COLORS.red,
        delay: ALERT_DELAY,
      }))
      return err
    }
  }
}
